import { useMediaApplicationContext } from '../../../../../../components/MediaApplicationContext';
import { useFindBrandGeneralSettings } from '../../../../../../services/modules/brandGeneralSettings/brandGeneralSettings.queries';
import { useGetBrandContext } from '../../../../../../services/modules/context/context.queries';
import {
  useFindTeams,
  useGetAbilities,
  useGetTeam,
} from '../../../../../../services/modules/users/users.queries';
import useGeneralSettingsStore from '../../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { useApplicationContext } from '../../../../../context/ApplicationContext/ApplicationContext';
import { QueryKeysAndFnOptions } from './useQueryKeysAndFnToCache.types';
import { DynamicQueryKeysAndFnFactory } from './utils/dynamicQueryKeysAndFnFactory/dynamicQueryKeysAndFn.factory';

export const useQueryKeysAndFnToCache = () => {
  const { isSeller, team } = useApplicationContext();
  const { webpEnabled } = useMediaApplicationContext();
  const { generalSettings } = useGeneralSettingsStore();

  const { queryKey: getUseGetTeamKey, queryFn: getUseGetTeamFn } = useGetTeam({
    enabled: false,
  });
  const { queryKey: getUseGetAbilitiesKey, queryFn: getUseGetAbilitiesFn } = useGetAbilities({
    enabled: false,
  });
  const { queryKey: getUseGetBrandContextKey, queryFn: getUseGetBrandContextFn } =
    useGetBrandContext({
      enabled: false,
    });
  const { queryKey: getUseFindTeamsKey, queryFn: getUseFindTeamsFn } = useFindTeams({
    enabled: false,
  });

  const {
    queryKey: getUseFindBrangGeneralSettingsKey,
    queryFn: getUseFindBrandGeneralSettingsContextFn,
  } = useFindBrandGeneralSettings({
    options: { enabled: false },
  });

  const staticQueryKeysAndFn: QueryKeysAndFnOptions = [
    {
      priority: 1,
      useReactQuery: true,
      queryKey: getUseGetTeamKey,
      queryFn: getUseGetTeamFn,
    },
    {
      priority: 1,
      useReactQuery: true,
      queryKey: getUseGetBrandContextKey,
      queryFn: getUseGetBrandContextFn,
    },
    {
      priority: 1,
      useReactQuery: true,
      queryKey: getUseFindBrangGeneralSettingsKey,
      queryFn: getUseFindBrandGeneralSettingsContextFn,
    },
    {
      priority: 1,
      useReactQuery: true,
      queryFn: getUseFindTeamsFn,
      queryKey: getUseFindTeamsKey,
    },
    {
      priority: 1,
      useReactQuery: true,
      queryKey: getUseGetAbilitiesKey,
      queryFn: async () => {
        const response = await getUseGetAbilitiesFn();

        if (!response.ok) {
          throw response.data;
        }

        return { data: response.data, ok: response.ok, status: response.status };
      },
    },
  ];

  const getQueryKeysAndFn = async (): Promise<QueryKeysAndFnOptions> => {
    if (!team) {
      return [];
    }

    const dynamicQueryKeysAndFnFactory = new DynamicQueryKeysAndFnFactory({
      isSeller,
      webpEnabled,
      userTeam: team,
      generalSettings,
    });

    const dynamicQueryKeysAndFn = await dynamicQueryKeysAndFnFactory.create();

    return [...staticQueryKeysAndFn, ...dynamicQueryKeysAndFn];
  };

  return { getQueryKeysAndFn, staticQueryKeysAndFn };
};
